export function ChevronUpDownIcon({ className = "w-6 h-6" }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      data-icontype="upDown"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
    </svg>
  );
}

export function ChevronSmallUpIcon({ className = "w-6 h-6" }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      data-icontype="up"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 13.875 12 10.375 15.75 13.875" />
    </svg>
  );
}

export function ChevronSmallDownIcon({ className = "w-6 h-6" }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
      data-icontype="down"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 10.375 12 13.875 15.75 10.375" />
    </svg>
  );
}
